import common from "../common";

export default class ShockWave extends PIXI.Container
{
    constructor()
    {
        super();

        this.radius = 0;
        this.damage = 0;
        this.incapacitate = false;
        this.progress = 0;
        this.currentTime = 0;
        this.totalTime = 0;
        this.affectedFighters = null; 

        this.tempGraphic = new PIXI.Graphics();
        this.addChild(this.tempGraphic);

        this.init();
    }

    init(radius, damage, incapacitate)
    {
        this.radius = radius;
        this.damage = damage;
        this.incapacitate = incapacitate;
        this.progress = 0;
        this.currentTime = 0;
        this.totalTime = 0.25;
        this.affectedFighters = [];
    }

    destroy()
    { 
        super.destroy();
    }

    update()
    {
        this.currentTime += P3.Ticker.dt * common.timeStretch;
        if(this.currentTime > this.totalTime)
        {
            return true;
        }
        this.progress = Math.sin(this.currentTime / this.totalTime);

        /*
        this.tempGraphic.clear();
        this.tempGraphic.lineStyle(1, 0x000000);
        this.tempGraphic.drawCircle(0, 0, this.radius * this.progress);
        */

        return false;
    }

    reset()
    {
        this.tempGraphic.clear();
        this.radius = 0;
        this.damage = 0;
        this.incapacitate = false;
        this.progress = 0;
        this.currentTime = 0;
        this.totalTime = 0;
        this.affectedFighters = null;
    }

    getRange(x, y)
    {
        var hyp = Math.sqrt(Math.pow(y - this.y, 2) + Math.pow(x - this.x, 2));
        if(hyp < this.radius * this.progress)
        {
            return {damage:this.damage * (1-this.progress), percent:1-this.progress, incapacitate: this.incapacitate};
        }
        return {damage:0, percent:0, incapacitate:false};
    }
}